<div class="media-settings-container" [attr.data-testid]="testIds.mediaSettingsContainer">
  <ng-template #mediaHeaderActionsTpl>
    <div class="view-toggle-buttons" [attr.data-testid]="testIds.viewToggleButtons">
      <span class="view-mode-text" [attr.data-testid]="testIds.viewModeText">
        {{ viewMode === 'list' ? 'Liste' : 'Grid' }}
      </span>
      <button
        mat-icon-button
        (click)="setViewMode('list')"
        [class.active]="viewMode === 'list'"
        [attr.data-testid]="testIds.buttonListView">
        <mat-icon svgIcon="list-icon" [attr.data-testid]="testIds.iconListView"></mat-icon>
      </button>
      <button
        mat-icon-button
        (click)="setViewMode('grid')"
        [class.active]="viewMode === 'grid'"
        [attr.data-testid]="testIds.buttonGridView">
        <mat-icon svgIcon="grid-icon" [attr.data-testid]="testIds.iconGridView"></mat-icon>
      </button>
    </div>
  </ng-template>
  <div class="media-section" [attr.data-testid]="testIds.mediaSection">
    <div
      class="media-list"
      [class.grid-view]="viewMode === 'grid'"
      [class.list-view]="viewMode === 'list'"
      [attr.data-testid]="testIds.mediaList">
      @for (message of displayedMediaMessages; track message.eventId) {
        <div
          class="media-item"
          [attr.data-testid]="testIds.mediaItem"
          tabindex="0"
          [class.selected]="message.eventId && selectedMessages.has(message.eventId!)"
          [class.disabled]="!isFileAllowed(message)"
          (click)="isFileAllowed(message) ? toggleMessageSelection($event, message.eventId) : null"
          (keydown.enter)="toggleMessageSelection($event, message.eventId)">
          <mat-checkbox
            tabindex="-1"
            class="tim-checkbox"
            [checked]="message.eventId ? selectedMessages.has(message.eventId!) : false"
            [disabled]="!isFileAllowed(message)"
            (change)="toggleMessageSelection($event, message.eventId)"
            [attr.data-testid]="testIds.checkboxSelectMessage">
          </mat-checkbox>

          <div class="media-icon" [attr.data-testid]="testIds.mediaIcon">
            <mat-icon [attr.data-testid]="testIds.messageTypeIcon" [svgIcon]="getFileIcon(message)"></mat-icon>
          </div>

          <div class="media-info" [attr.data-testid]="testIds.mediaInfo">
            <span class="media-name" [attr.data-testid]="testIds.mediaName">
              {{ getFileTypeDisplayName(message) }}
            </span>
            <span class="media-owner" [attr.data-testid]="testIds.mediaOwner">
              {{ message.sender || 'Unknown sender' }}
            </span>
          </div>

          <div class="media-meta" [attr.data-testid]="testIds.mediaMeta">
            @if (getFileSize(message) > 0) {
              <span class="media-size" [attr.data-testid]="testIds.mediaSize">
                {{ mediaService.formatFileSize(getFileSize(message)) }}
              </span>
            }
            @if (message.date) {
              <span class="media-date" [attr.data-testid]="testIds.mediaDate">
                {{ message.date | date: 'dd.MM.yyyy' }}
              </span>
            }
          </div>
        </div>
      } @empty {
        <div class="no-files" [attr.data-testid]="testIds.noFilesMessage">Keine Medien in diesem Chat</div>
      }
    </div>

    @if (mediaMessages.length > 0) {
      <div class="media-actions-row">
        <div class="paginator-container">
          <mat-paginator
            [length]="mediaMessages.length"
            [pageSize]="pageSize"
            [pageSizeOptions]="[]"
            [hidePageSize]="true"
            (page)="handlePageEvent($event)"
            aria-label="Select page"
            [attr.data-testid]="testIds.mediaPaginator">
          </mat-paginator>
        </div>
        <div class="media-footer" [attr.data-testid]="testIds.mediaFooter">
          <app-button
            [text]="getDownloadButtonText()"
            [isPrimary]="false"
            [isDisabled]="!anySelected"
            (click)="downloadSelectedFiles()"
            (keydown)="$event.stopPropagation()"
            [attr.data-testid]="testIds.buttonDownloadSelected">
          </app-button>
        </div>
      </div>
    }
  </div>
</div>
